import {CheckoutStep} from '@/lib/constants';

import {
    AvailablePaymentMethod,
    AvailableShippingMethod,
    CartAddressInput,
    CartItemInterface,
    CartPrices,
    SelectedPaymentMethod,
    SelectedShippingMethod,
    ShippingCartAddress,
} from '__generated__/__types__';
import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

const initialCartId: string = '';

const initialAvailablePaymentMethodsState: AvailablePaymentMethod[] = [
    {
        code: '',
        title: '',
    },
];

export const initialSelectedShippingMethodState: SelectedShippingMethod = {
    amount: {
        value: 0,
    },
    method_title: '',
    method_code: '',
    carrier_code: '',
    carrier_title: '',
};

const initialAvailableShippingMethods: AvailableShippingMethod[] = [
    {
        amount: {
            value: 0,
        },
        carrier_title: '',
        carrier_code: '',
        method_code: '',
        method_title: '',
        available: true,
        price_excl_tax: {
            currency: undefined,
            value: 0,
        },
        price_incl_tax: {
            currency: undefined,
            value: 0,
        },
    },
];

const initialCartPrices: CartPrices = {
    grand_total: {
        value: 0,
    },
    subtotal_excluding_tax: {
        value: 0,
    },
};

export const initialSelectedPaymentMethod: SelectedPaymentMethod = {
    code: '',
    title: '',
};

const initialEmail: string = '';

const initialCartItems: CartItemInterface[] = [];

export const cartIdAtom = atomWithStorage('cartId', initialCartId);
export const cartIdLoadingAtom = atom(false);

export const availablePaymentMethodAtom = atom(initialAvailablePaymentMethodsState);

export const selectedShippingMethodAtom = atom(initialSelectedShippingMethodState);

export const cartTotalAtom = atomWithStorage('xCartTotal', initialCartPrices);

export const cartTotalLoadingAtom = atom(false);

export const cartItemsAtom = atomWithStorage('xCartItems', initialCartItems);

export const selectedPaymentMethodAtom = atom(initialSelectedPaymentMethod);

export const availableShippingMethodsAtom = atom(initialAvailableShippingMethods);

export const emailAtom = atomWithStorage('email', initialEmail);
export const saveAddressBookCheckedAtom = atom(false);

export const currentCheckoutStepAtom = atom<number>(CheckoutStep.shippingAddress);

export const acceptedTermAtom = atom(true);

export const acceptedPolicyAtom = atom(true);
export const isNoCallConfirmAtom = atom(true);
export const appliedCouponAtom = atom<string>('');

export const convertAddressInputToShippingCartAddress = (
    addressInput: CartAddressInput | null,
): ShippingCartAddress => {
    if (!addressInput) return {} as ShippingCartAddress;
    return {
        __typename: 'ShippingCartAddress',
        city: addressInput.city,
        company: addressInput.company,
        district_id: addressInput.district_id,
        ward_id: addressInput.ward_id,
        firstname: addressInput.firstname,
        lastname: addressInput.lastname,
        telephone: addressInput.telephone,
        street: addressInput.street,
        ward: addressInput.ward,
        district: addressInput.district,
        region: {
            __typename: 'CartAddressRegion',
            label: addressInput.region || '',
            code: addressInput.region || '',
        },
        country: {
            __typename: 'CartAddressCountry',
            label: addressInput.country_code || '',
            code: addressInput.country_code || '',
        },
        postcode: addressInput.postcode,
    };
};
